// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"eV","contentFrame":"eW","buttonGroup":"eX","button":"eY","header":"eZ","text":"e0","contentImage":"e1","closeButton":"e2"};